<mat-form-field appearance="outline">
  <input
    matInput
    class="pb-[0.1rem]"
    [formControl]="searchBarControl"
    [name]="'search'"
    [placeholder]="placeholder"
    [matAutocomplete]="autoCompleteId"
  />
  <mat-autocomplete
    [panelWidth]="'fit'"
    #autoCompleteId="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
  >
    <ng-container
      *ngIf="searchList && searchList.length && !isSearching; else noData"
    >
      <mat-option
        *ngFor="let search of searchList"
        [value]="search"
        class="text-sm"
      >
        {{ search.displayName }}
      </mat-option>
    </ng-container>
    <ng-template #noData>
      <mat-option *ngIf="!!searchBarControl.value && !isSearching" disabled>
        No results
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</mat-form-field>
<div class="flex items-center pb-4 gap-x-2" *ngIf="isSearching">
  <mat-spinner [diameter]="17"></mat-spinner>
  <span>Searching</span>
</div>
